<div class="city_card_body scroll">
    <div class="analytic_title">{{ textsCityCard.cityProfile }}</div>
    <cs-analytic
        [distributionSummary]="testData ? testData : cityCard.city.distributionSummary"
        [isDemo]="!!testData"
    ></cs-analytic>
</div>
